import React, { useState, useEffect } from 'react';

import { 
  CCard, 
  CCardBody, 
  CCardHeader, 
  CRow, 
  CCol, 
  CSpinner,
  CBadge,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell
} from '@coreui/react';
import useApi from '../../../config/useApi';

export default function Home() {
  const [challansData, setChallansData] = useState([]);
  const [loginHistory, setLoginHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const { Get } = useApi();

  // Function to fetch data from the API with pagination support
  const fetchAllData = async (url) => {
    let allData = [];
    let nextUrl = url;

    while (nextUrl) {
      try {
        const data = await Get(nextUrl);
        allData = [...allData, ...data.results];
        nextUrl = data.next;
      } catch (error) {
        console.error('Error fetching data:', error);
        break;
      }
    }
    return allData;
  };

  // Get client IP address using a free API
  const getClientIP = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching IP:', error);
      return 'Unknown';
    }
  };

  // Store login information in localStorage
  const storeLoginInfo = async () => {
    const ip = await getClientIP();
    const loginInfo = {
      ip_address: ip,
      user_agent: navigator.userAgent,
      login_time: new Date().toISOString(),
      success: true
    };

    // Get existing history or initialize empty array
    const existingHistory = JSON.parse(localStorage.getItem('loginHistory') || '[]');
    
    // Add new login info and keep only last 10 entries
    const updatedHistory = [loginInfo, ...existingHistory].slice(0, 10);
    
    localStorage.setItem('loginHistory', JSON.stringify(updatedHistory));
    setLoginHistory(updatedHistory);
  };

  // Fetch data from the API when the component mounts
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const allChallansData = await fetchAllData('challans');
        setChallansData(allChallansData);
        
        // Load login history from localStorage
        const storedHistory = JSON.parse(localStorage.getItem('loginHistory') || '[]');
        setLoginHistory(storedHistory);
        
        // Store current login if not already stored
        if (storedHistory.length === 0 || 
            new Date(storedHistory[0].login_time).toDateString() !== new Date().toDateString()) {
          await storeLoginInfo();
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Calculate the total number of unique customers
  const customerNames = new Set(challansData.map(challan => challan.customer_name));
  const totalCustomers = customerNames.size;

  // Calculate the total number of challans
  const totalChallanNumber = challansData.length;

  if (loading) {
    return (
      <div className="text-center">
        <CSpinner color="primary" />
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <CRow>
        

        {/* Total Customers */}
        <CCol xs="12" md="4">
          <CCard>
            <CCardHeader>Total Customers</CCardHeader>
            <CCardBody style={{ padding: '2rem', backgroundColor: '#f5f8fa', borderRadius: '10px', textAlign: 'center' }}>
              <h3 style={{ color: '#7e8c8d', fontWeight: 'bold' }}>{totalCustomers}</h3>
            </CCardBody>
          </CCard>
        </CCol>

        {/* Total Challan Numbers */}
        <CCol xs="12" md="4">
          <CCard>
            <CCardHeader>Total Challan Numbers</CCardHeader>
            <CCardBody style={{ padding: '2rem', backgroundColor: '#f5f8fa', borderRadius: '10px', textAlign: 'center' }}>
              <h3 style={{ color: '#e67e22', fontWeight: 'bold' }}>{totalChallanNumber}</h3>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      {/* Login History Section */}
      <CRow className="mt-4">
        <CCol xs="12">
          <CCard>
            <CCardHeader>Recent Logins (Last 10)</CCardHeader>
            <CCardBody>
              {loginHistory.length === 0 ? (
                <div className="text-center text-muted">No login history found</div>
              ) : (
                <CTable hover striped bordered size="sm">
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell>IP Address</CTableHeaderCell>
                      <CTableHeaderCell>Device/Browser</CTableHeaderCell>
                      <CTableHeaderCell>Date & Time</CTableHeaderCell>
                      <CTableHeaderCell>Status</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {loginHistory.map((item, index) => (
                      <CTableRow key={index}>
                        <CTableDataCell>{item.ip_address}</CTableDataCell>
                        <CTableDataCell>{item.user_agent.split(' ')[0]}</CTableDataCell>
                        <CTableDataCell>{new Date(item.login_time).toLocaleString()}</CTableDataCell>
                        <CTableDataCell>
                          <CBadge color={item.success ? 'success' : 'danger'}>
                            {item.success ? 'Success' : 'Failed'}
                          </CBadge>
                        </CTableDataCell>
                      </CTableRow>
                    ))}
                  </CTableBody>
                </CTable>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
}